<template>
    <div>
    <b-row style="min-height: 681px;">
        <b-col sm="12">
            <b-card>
                <b-row class="mt-sm-2">
                    <b-col sm="12">
                        <b-row>
                            <b-col sm="2">
                                <span class="pr-"><strong>총 {{ totalRows | numberComma }}건</strong></span>
                            </b-col>
                            <b-col sm="6">
                            </b-col>
                            <b-col sm="2">
                                <b-button v-if="!isDownload" variant="outline-primary" style="float:right"
                                    v-on:click="downloadUserList()">엑셀 다운로드</b-button>
                                <b-button v-else variant="outline-primary" style="float:right;cursor: default;"><span
                                        class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    엑셀 다운로드</b-button>
                            </b-col>
                            <b-col md="2">
                                <b-form-group label-cols-sm="5" label="" class="mb-0">
                                    <b-form-select v-model="rowPage" :options="pageOptions"
                                        v-on:change="findCompanyUser"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>

                    <!-- 로딩 -->
                    <b-col sm="12" v-show="listLoading">
                        <b-row>
                        <b-col sm="5"></b-col>
                        <b-col sm="5" class="pt-5 pb-5">
                            <PulseLoader color='#20a8d8'></PulseLoader>
                        </b-col>
                        </b-row>
                    </b-col>

                    <!-- 목록 -->
                    <b-col sm="12" class="pt-sm-1" v-show="!listLoading">
                        <b-row>
                            <b-col sm="12">
                                <b-table
                                outlined
                                :fields="fields"
                                :items="items"
                                >
                                <template slot="user_id" slot-scope="row">
                                    <a href="javascript:void(0)" v-on:click="rowSelected(row.item)">{{row.item.user_id}}</a>
                                </template>
                                <template slot="period_name" slot-scope="row">
                                    {{ row.item.period_name }} 개월
                                </template>
                                <template slot="auth_start_date" slot-scope="row">
                                    {{ row.item.auth_start_date }} ~ {{ row.item.auth_end_date }}
                                </template>
                                </b-table>
                            </b-col>                            
                        </b-row>
                    </b-col>

                    <!-- 페이징 -->
                    <b-col sm="10" class="pt-sm-1">
                        <b-row class="pb-sm-2">
                        <b-col sm="1"></b-col>
                        <b-col sm="10" class="my-1">
                            <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="rowPage"
                            :limit="limitPage"
                            @input="findCompanyUserPage"
                            align="center"
                            ></b-pagination>
                        </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="2" class="pt-sm-1" style="text-align: right;">
                        <b-button variant="primary" v-on:click="fnGoRegist">구독회원 등록</b-button>
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
    </b-row>
    <!-- 엑셀 다운로드 사유 모달 -->
    <b-modal title="엑셀 다운로드 사유" v-model="excelDownloadModal" @ok="realDownloadUserList" centered>
        <b-form-group label="다운로드 사유를 선택해주세요">
        <b-form-select v-model="selectedReason" :options="downloadReasonOptions">
            <template slot="first">
            <option :value="null" disabled>-- 선택하세요 --</option>
            </template>
        </b-form-select>
        </b-form-group>
    </b-modal>
    </div>
</template>
<script>

import Vue from 'vue'
import VeeValidate from 'vee-validate'

const moment = require("moment");

import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

import { EventBus } from "../../../event-bus";
import swal from 'sweetalert2';

Vue.use(VeeValidate, {
    inject: true,
    fieldsBagName: 'veeFields'
});

export default {
    name: "companyUserList",
    components: {
        PulseLoader,
    },
    props: {
        queryParams: {},
        fullDate: {
            type: Array,
        },
    },
    created() {
        // 이벤트 버스 선언
        EventBus.$on('callFindCompanyUser', () => {
            this.findCompanyUser();
        });
    },
    data() {
        return {
            listLoading: false,
            totalRows: 0,
            currentPage: 1,
            limitPage: 10,
            rowPage: 10,
            pageOptions: [10, 30, 50, 100],
            fields: [
                { 'p_type_name': { 'label': '사용자구분', } },
                { 'user_id': { 'label': '아이디', } },
                { 'company_name': { 'label': '회사명', } },
                { 'user_name': { 'label': '담당자명', } },
                { 'auth_download_name': { 'label': '다운로드형식', } },
                { 'period_name': { 'label': '상품 기간', } },
                { 'auth_start_date': { 'label': '이용기간', } },
                { 'last_login_date': { 'label': '최근 로그인', } },
                { 'auth_active_state_name': { 'label': '상태', } },
            ],
            items: [],
            isDownload: false,
            // 엑셀 다운로드 관련
            excelDownloadModal: false,
            downloadReasonOptions: [],
            selectedReason: null,
        }
    },
    mounted() {
        this.findCompanyUser();
        // 다운로드 사유 코드 조회
        this.getDownloadReasonCode();
    },
    methods: {
        findCompanyUser() {
            // console.log('>>>>> ', this.queryParams, this.fullDate);
            this.listLoading = true;
            this.currentPage = 1;

            this.queryParams.search_start_date = this.$parent.getFormatDate(this.fullDate[0])
            this.queryParams.search_end_date = this.$parent.getFormatDate(this.fullDate[1])

            this.queryParams.rowPage = this.rowPage;
            this.queryParams.currentPage = this.currentPage - 1;

            // console.log('>>>>> ', this.queryParams);
            var param = encodeURI(JSON.stringify(this.queryParams));
            var data = new FormData();
            data.append('objs', param);

            this.getList(data);
        },
        findCompanyUserPage() {
            this.listLoading = true;
            this.queryParams.search_start_date = this.$parent.getFormatDate(this.fullDate[0])
            this.queryParams.search_end_date = this.$parent.getFormatDate(this.fullDate[1])
            
            this.queryParams.rowPage = this.rowPage;
            this.queryParams.currentPage = this.currentPage - 1;
            
            var param = encodeURI(JSON.stringify(this.queryParams));
            var data = new FormData();
            data.append('objs', param);

            this.getList(data);
        },
        getList(data) {
            var token = sessionStorage.getItem("myToken");

            this.$http.post('/api/select/companyUserManagerList?access_token=' + token, data, null)
                .then((result) => {
                    this.listLoading = false;
                    const {resultListCount, resultList} = result.data;
                    // console.log('getList : ', resultListCount, resultList);
                    this.totalRows = resultListCount;
                    this.items = [];
                    this.items = resultList;
                    // this.totalRows = this.items.length;
                    if(this.search_user_id !== '' && this.search_user_id !== undefined){
                        this.$parent.rowSessionSelected();
                    }
                });
        },
        getDownloadReasonCode() {
            var token = sessionStorage.getItem("myToken");
            this.$http.get('/api/select/itemCodeList?access_token=' + token + '&parentCode=PRV_EXCEL_DWN_REASON')
                .then((result) => {
                this.downloadReasonOptions = result.data.map(item => {
                    return { value: item.item_code, text: item.item_name };
                });
                })
        },
        downloadUserList() {
            // 모달 오픈 전 초기화
            this.selectedReason = null;
            this.excelDownloadModal = true;
        },
        realDownloadUserList(bvModalEvt) {
            if (!this.selectedReason) {
                bvModalEvt.preventDefault();
                swal.fire({
                    type: 'warning',
                    title: '다운로드 사유를 선택해주세요.',
                    showConfirmButton: false,
                    timer: 1500
                });
                return;
            }

            this.isDownload = true;
            this.currentPage = 1;

            this.queryParams.search_start_date = this.$parent.getFormatDate(this.fullDate[0])
            this.queryParams.search_end_date = this.$parent.getFormatDate(this.fullDate[1])

            this.queryParams.rowPage = this.rowPage;
            this.queryParams.currentPage = this.currentPage - 1;

            // 사유 파라미터 추가
            const { manager_id } = this.$session.get("userInfo");
            this.queryParams.manageId = manager_id;
            this.queryParams.downloadReason = this.selectedReason;
            this.queryParams.downloadType = 'S'; // 구독회원 다운로드

            var param = encodeURI(JSON.stringify(this.queryParams));
            var data = new FormData();
            data.append('objs', param);

            var config = {
                responseType: 'blob'
            };

            this.$http.post('/download/companyUserManagerListExcel', data, config)
                .then((result) => {
                    const url = window.URL.createObjectURL(new Blob([result.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    var fileName = "구독회원리스트_" + moment().format('YYYYMMDD');
                    link.setAttribute('download', fileName + '.xlsx'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    this.isDownload = false;
                    this.excelDownloadModal = false;
                })
                .catch(error => {
                    console.error(error);
                    swal.fire({
                        type: 'error',
                        title: '다운로드 실패',
                        text: '관리자에게 문의해주세요.',
                    });
                    this.isDownload = false;
                });
        },
        rowSelected(item) {
            // console.log(item);
            this.$session.set('usermanage_user_id', item.user_id);
            this.$router.push({ path: '/user/companyusermanagedetail' });
        },
        fnGoRegist() {
            this.$session.set('usermanage_user_id', '');
            this.$router.push({ path: '/user/companyusermanagedetail' });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/user/companyUserList/component/CompanyUserList.vue